// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import WishListCatalog from '../components/WishListCatalog/WishListCatalog';
import { actions } from '../duck';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingWishLists: state.wishListCatalog.isFetchingWishLists,
    wishLists: state.wishListCatalog.wishLists,
    fetchWishListsError: state.wishListCatalog.fetchWishListsError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...actions,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WishListCatalog);



// WEBPACK FOOTER //
// ./src/modules/wish-list-catalog/containers/WishListCatalogContainer.jsx